import { useEffect, useId, useState } from "react";
import { artworkReelExamples } from "./artwork";

export function ArtworkReel() {
  const descriptionId = useId();
  const [paused, setPaused] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setReducedMotion(preference.matches);
    preference.addEventListener("change", onChange);
    return () => preference.removeEventListener("change", onChange);
  }, []);

  return <div className="landing-reel" role="region" aria-label="Artwork to stencil preview" aria-describedby={descriptionId} data-motion={paused || reducedMotion ? "paused" : "playing"}>
    <p className="landing-sr-only" id={descriptionId}>Portraits, tattoos, and drawings move through one fixed line. Their original images appear on the left, and their matching stencil images appear on the right.</p>
    <div className="landing-reel__viewport">
      {/* Identical tracks and timing keep every original/output pair registered.
          The masks stay on the viewport, so only the artwork crosses the line. */}
      {(["original", "stencil"] as const).map(version => <div className={`landing-reel__layer landing-reel__layer--${version}`} key={version} aria-hidden="true">
        <div className="landing-reel__track">
          {[0, 1, 2].map(copy => <div className="landing-reel__group" key={copy}>
            {artworkReelExamples.map(example => <div className="landing-reel__card" key={example.id} data-style={example.style}>
              <img src={version === "original" ? example.original : example.stencil} alt="" width="640" height="960" draggable={false} />
              <span>{example.label}</span>
            </div>)}
          </div>)}
        </div>
      </div>)}
      <div className="landing-reel__line" aria-hidden="true">
        <span className="landing-reel__generation">Stencil preview</span>
      </div>
      {!reducedMotion && <button className="landing-reel__pause" type="button" onClick={() => setPaused(value => !value)} aria-label={paused ? "Play artwork animation" : "Pause artwork animation"}>
        <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">{paused ? <path d="m5 2 9 6-9 6Z" /> : <path d="M4 2h3v12H4zm5 0h3v12H9z" />}</svg>
        {paused ? "Play" : "Pause"}
      </button>}
    </div>
  </div>;
}
